import { graphql } from '@api/generated';

export const UPSERT_INTERACTION_BY_CHANNEL_ID_MUTATION = graphql(`
  mutation upsertInteractionByChannelId(
    $channelId: ID!
    $input: InteractionUpsertInput!
  ) {
    upsertInteractionByChannelId(channelId: $channelId, input: $input) {
      id
      status
      displayId
      contactCenter {
        id
        name
      }
    }
  }
`);

export const UPDATE_INTERACTION_BY_CHANNEL_ID_MUTATION = graphql(`
  mutation updateInteractionByChannelId(
    $channelId: ID!
    $tenantId: ID!
    $input: InteractionUpdateInput!
  ) {
    updateInteractionByChannelId(
      channelId: $channelId
      tenantId: $tenantId
      input: $input
    ) {
      id
      status
      displayId
      contactCenter {
        id
        name
      }
    }
  }
`);
